import './index.scss'
import { __ } from '@wordpress/i18n';
import classnames from 'classnames'

import { backgroundRepeatList, svgBackgroundList, backgroundSizeList, backgroundPositionList } from './backgroundlist.js'
import  ResetAttributes  from '../../../general/ResetButton.js'


import { useEffect, useRef } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';


import { InspectorControls } from '@wordpress/block-editor';
import { 
  PanelBody,	
  SelectControl,
  TextControl, 
  RangeControl, 
  ExternalLink,	  
  Flex, FlexItem,
  ToggleControl
} from '@wordpress/components';


const allowedBlocks = [ 'core/cover' ];
const acoverDefaults = {
	aOn: false,
  svg: '',
  customsvg: '',        
  bgsize: '',
  custombgsize:'',
  bgrepeat: '',
  bgposition: ''	
};


const addAttributes = ( settings, name ) => {    
    
  if (!allowedBlocks.includes(name))  return settings;  
  
  if (typeof settings.attributes !== 'undefined') {
		settings.attributes = {
			...settings.attributes,
      acover:{
        type: 'object',
				default: acoverDefaults,
      }
      
    }
  }

  return settings;
}


const addInspectorControl = (BlockEdit) => (props) => {
	if (!allowedBlocks.includes(props.name)) return <BlockEdit {...props} />;


      const { attributes, setAttributes } = props;
      const { acover } = attributes;

      const orgDefaults = {
        ...acoverDefaults,
        ...(attributes.acover || {}),
      };

      const { 
        aOn,
        svg,
        customsvg,        
        bgsize,
        custombgsize,
        bgrepeat,
        bgposition,
      } = orgDefaults;

     
      const isDifferentFromDefault = JSON.stringify({ ...acover, aOn: undefined }) !== JSON.stringify({ ...acoverDefaults, aOn: undefined });

      const updateObject = (obj, key, newVal) => ({ ...obj, [key]: newVal });
      const updateArray = (list, index, newVal) => {
        const listsCopy = [...list];
        listsCopy[index] = newVal;
        return listsCopy;
      }

      return (
          <>
            <BlockEdit { ...props } />

            <InspectorControls group="settings">
             
              <Flex direction="column" style={{padding: "5px 15px", marginTop: "1rem"}  }> 					
                
                <Flex>
                  <FlexItem>
                    <ToggleControl
                      label={__('Enable Cover', 'aver')}
                      checked={aOn}
                      onChange={(val) => setAttributes({ acover: {...acover, aOn: val }})}
                    />
                  </FlexItem>
                  <FlexItem>
                    { isDifferentFromDefault && (
                      <ResetAttributes
                        onConfirm={() => {
                          setAttributes({
                            acover: acoverDefaults
                          });								
                        }}
                      /> 
                    )}
                  </FlexItem>
                </Flex>					
                
                { aOn &&  <>
                
                  <SelectControl
                    label={ __( 'SVG Background', 'aver' ) }
                    options={ svgBackgroundList }
                    value={ svg }
                    onChange={ (newval) => setAttributes({ acover : {...acover, svg:newval } }) }		
                  />

                  { svg == 'custom' &&    
                    <div className='panel-group'>
                      <TextControl
                        label={ __( 'Other SVG Background', 'aver' ) }
                        value={ customsvg }
                        onChange={ (newval) => setAttributes({ acover : {...acover, customsvg:newval } }) }	
                        help={	__('url("data:image/svg+xml,...")','aver')	}				
                      />
                      <ExternalLink href="https://heropatterns.com/"> 
                        {__('heropatterns.com', 'aver')}
                      </ExternalLink>					
                    </div>
                  }        
                             
                  <SelectControl
                    label={ __( 'Background Size', 'aver' ) }
                    options={ backgroundSizeList }
                    value={ bgsize }
                    onChange={ (newval) => setAttributes({ acover : {...acover, bgsize:newval } }) }	
                  />
      
                  { bgsize == 'custom' && 
                    <RangeControl
                      label={ __( 'Background Size(%)', 'aver' ) }
                      value={ custombgsize }
                      min={ 0 }
                      max={ 100 }
                      step={ 1 }
                      onChange={ (newval) => setAttributes({ acover : {...acover, custombgsize:newval } }) }	
                    />              
                  }
      
                  <SelectControl
                    label={ __( 'Background Position', 'aver' ) }
                    options={ backgroundPositionList }
                    value={ bgposition }
                    onChange={ (newval) => setAttributes({ acover : {...acover, bgposition:newval } }) }	
                  />	
      
                  <SelectControl
                    label={ __( 'Background Repeat', 'aver' ) }
                    options={ backgroundRepeatList }
                    value={ bgrepeat }
                    onChange={ (newval) => setAttributes({ acover : {...acover, bgrepeat:newval } }) }	
                  /> 

                    
                </> }             

              </Flex>  

            </InspectorControls>
          </>
      )
  }





const applyExtraClassEditor = (BlockListBlock) => (props) => {
    
  if ( ! allowedBlocks.includes( props.name ) ) return <BlockListBlock { ...props } />    

  const { attributes, wrapperProps, className } = props;
  const { acover } = attributes;


  
  const orgDefaults = {
    ...acoverDefaults,
    ...(attributes.acover || {}),
  };

  const { 
    aOn,
    svg,
    customsvg,        
    bgsize,
    custombgsize,
    bgrepeat,
    bgposition,
  } = orgDefaults;

	if (!aOn) return <BlockListBlock {...props} />;

 // console.log(attributes)


    const cssstyle = { 
      ...wrapperProps?.style,      
    }		    

    const ref = useRef();
  
    const classes = classnames(
      className, ``, 
      {  
        [ svg ]  : svg != 'custom',          
      }
    );

    useEffect(() => {
      if (ref.current) {
       
        const innerContainer = ref.current.querySelector('.wp-block-cover__background');
       
        if (innerContainer && acover) {

          //console.log(acover);
          const styles = {
            ...(wrapperProps?.style || {}), // preserve existing styles
            ...(svg === 'custom' && customsvg && {
              backgroundImage: customsvg
            }),               
            ...(bgsize === 'custom' && custombgsize && {
              backgroundSize: `${custombgsize}%`
            }),
            ...(bgsize && bgsize !== 'custom' && {
              backgroundSize: bgsize
            }),
            ...(bgposition && { backgroundPosition: bgposition }),
            ...(bgrepeat && { backgroundRepeat: bgrepeat }),
          };

          //console.log(styles)

          Object.assign(innerContainer.style, styles);
        }
      }
    }, [svg, customsvg, bgsize, custombgsize, bgrepeat, bgposition]
  );  
  
    return (
      <div ref={ref}>
          <BlockListBlock
            {...props		} 
            wrapperProps={ { style : cssstyle } } 			
            className= { classes }				
          />
      </div>
    );      
}


const applyExtraClassSave = (extraProps, blockType, attributes) => {
	
	if (!allowedBlocks.includes(blockType?.name)) {
		return extraProps;
	}

	const { acover } = attributes;
	if (!acover) return extraProps;	
	
	const isDifferentFromDefault = JSON.stringify({ ...acover, aOn: undefined }) !== JSON.stringify({ ...acoverDefaults, aOn: undefined });	
 	if (!isDifferentFromDefault) return extraProps;

	const updatedata = {}; 

	for (const key in acover) {
		const val = acover[key];
		const def = acoverDefaults[key];

		if (val === undefined) continue;

		if (JSON.stringify(val) !== JSON.stringify(def) && val !== '') {
			updatedata[key] = val;			
		}
	}

	attributes.acover = updatedata;
	return extraProps;
};



addFilter(
    'blocks.registerBlockType',
    'aver/acover-attributes',
    addAttributes
);


addFilter(
    'editor.BlockEdit',
    'aver/acover-advanced-control',
    addInspectorControl
);


addFilter(
    'editor.BlockListBlock',
    'aver/acover-editor-class',
    applyExtraClassEditor
);

addFilter( 
  'blocks.getSaveContent.extraProps',  
  'aver/acover-save-class',  
  applyExtraClassSave 
);


